import { useRef } from "react";

/**
 * Al cambiar filtros, RTK conserva `data` del request anterior: eso es lo que hace posible
 * la regla de loading del repo (pintar el valor viejo con indicador mientras revalida, sin
 * overlay bloqueante). Pero no sirve cuando lo que cambio es el tenant: los numeros del
 * scope anterior quedarian con el color y el modo del nuevo. Por eso el placeholder vale
 * solo dentro del mismo scope; cambiar de tenant es carga fria y ahi si va overlay.
 */
export function useBenefitsMetricsQueryDisplay<T>(query: {
  data: T | undefined;
  currentData: T | undefined;
  isFetching: boolean;
  scopeKey: string;
}): {
  metrics: T | undefined;
  isBlockingLoading: boolean;
  isRefreshing: boolean;
} {
  const paintedScope = useRef<string | null>(null);
  if (query.currentData !== undefined) {
    paintedScope.current = query.scopeKey;
  }

  const placeholder =
    paintedScope.current === query.scopeKey ? query.data : undefined;
  const metrics = query.currentData ?? placeholder;

  return {
    metrics,
    isBlockingLoading: metrics === undefined && query.isFetching,
    isRefreshing: query.isFetching && metrics !== undefined,
  };
}
